export { fetchDrupalStaticDataFile } from './fetch';
export { connectDrupalStaticDataFile } from './connect';
